import {
	Component,
	ViewEncapsulation,
	EventEmitter,
	OnInit,
	OnChanges,
	OnDestroy,
	ViewChild,
	ElementRef
} from "@angular/core";
import { Subscription } from "rxjs/Subscription";

// Interfaces
import { IComponent } from "../../../interfaces";
// Services
import * as Srv from "../../../services";
// types
import { dialogTag } from "../../../types";
@Component({
	selector: "app-textbox-dialog",
	templateUrl: "./textbox-dialog.component.html",
	styleUrls: ["./textbox-dialog.component.scss"]
})
export class TextboxDialogComponent
	implements IComponent, OnInit, OnDestroy, OnChanges {
	// implements IComponent interfaces
	name = "TextboxDialogComponent";
	subscriptions: Subscription[] = [];

	// implements local variables
	@ViewChild("textarea")
	textarea: ElementRef;

	tag: dialogTag;
	constructor(
		private _loggerService: Srv.LogService,
		public dialogService: Srv.DialogService
	) {
		this.subscriptions.push(
			this.dialogService.OnOpenTextboxDialog$.subscribe(
				(tag: dialogTag) => {
					this.tag = tag;
					if (this.tag) {
					}
				}
			)
		);

		this.subscriptions.push(
			dialogService.OnClosingTextboxDialog$.subscribe(
				(value: dialogTag) => {
					this.tag = undefined;
				}
			)
		);

		this.subscriptions.push(
			dialogService.OnClose$.subscribe((value: any) => { })
		);
	}

	ngOnInit() { }

	ngOnDestroy() {
		this.subscriptions.forEach(s => {
			s.unsubscribe();
		});
		delete this.subscriptions;
	}

	ngOnChanges() {
		// this._loggerService.Debug(this.name, ['inputs:', { value: this.value }]);
	}

	onLeftClick(e: any) {
		// this._loggerService.Debug(this.name,
		// [this.dialogService.leftButtonText + 'Left button clicked', this.tag]);
		if (this.tag.tag == "RECOMMEND_SITEREVIEW_TOBOARD") {
			this.dialogService.ClickLeftTextDialog(this.tag);
			this.tag = undefined;
		} else {
			this.dialogService.CloseTextboxDialog(this.tag);
		}
		// this.tag = undefined;
	}

	onRightClick(e: any) {
		// this._loggerService.Debug(this.name, [this.dialogService.rightButtonText + 'Right button clicked', e]);
		this.tag.text = this.textarea.nativeElement.value;
		if (this.tag.text == "") {
			return;
		}

		if (this.textarea.nativeElement.type == "email") {
			if (!this.validateEmail(this.tag.text)) {
				return;
			}
		}
		this.dialogService.ClickRightTextboxDialog(this.tag);
		this.tag = undefined;
	}

	validateEmail(email) {
		var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	}

}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/components/dialog/textbox-dialog/textbox-dialog.component.ts